import React from 'react';
import { Button, Tooltip } from '@mui/material';
import MyLocation from '@mui/icons-material/MyLocation';

class GeoCoordinatesDisplay extends React.Component {
  render() {
    const { coordinates, onClick } = this.props;
    if (
      coordinates
      && (coordinates.length >= 2)
      && coordinates[0]
      && coordinates[1]
    ) {
      const displayLat = coordinates[1].toFixed(3);
      const displayLng = coordinates[0].toFixed(3);
      const mapLat = coordinates[1];
      const mapLng = coordinates[0];
      const latDirection = mapLat > 0 ? 'N' : 'S';
      const lngDirection = mapLng > 0 ? 'E' : 'W';
      // \xB0 retuns a degree symbol
      const displayString = `See asset on map at: ${displayLat}\xB0 ${latDirection}, ${displayLng}\xB0 ${lngDirection}`;

      return (
        <Tooltip title={displayString}>
          <Button
            onClick={(event) => {
              event.stopPropagation();
              onClick(coordinates);
            }}
          >
            <MyLocation />
          </Button>
        </Tooltip>
      );
    } else {
      return 'Unknown';
    }
  }
}

export default GeoCoordinatesDisplay;
